export const matchHomeID = match => match.hTeam.teamId;
